// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"AddAndEditCommunityModal--next-sr-only--1CmBV9I","footerButtonsContainer":"AddAndEditCommunityModal--footerButtonsContainer--vUjy89i"};